import React from 'react';
import { useTranslation } from 'react-i18next';

import logo100os from 'assets/images/logo-100os.svg';

import { iframeLink } from 'core/iframe';
import * as Alert from 'components/alert';
import { CONFIG } from 'config';

export function EntrepreneurInvite() {
    const { t } = useTranslation('home');

    // Create the alert element props
    const propsAlert = {
        // Set the image to be shown
        image: {
            src: logo100os,
            alt: t('glossary:100 Open Startups'),
        },
        // Show texts informations
        title: t('EntrepreneurInvite.title'),
        descr: t('EntrepreneurInvite.descr'),
        // Build the button
        buttn: {
            href: iframeLink(CONFIG.appLinks.startup),
            text: t('EntrepreneurInvite.button'),
        },
        // Setup color and presentation
        type: 'primary',
    };
    return <Alert.Alert {...propsAlert} />;
}
export default EntrepreneurInvite;
